(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteDialogController', PublicSiteDialogController);

    PublicSiteDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PublicSite'];

    function PublicSiteDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PublicSite) {
        var vm = this;

        vm.publicSite = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.publicSite.id !== null) {
                PublicSite.update(vm.publicSite, onSaveSuccess, onSaveError);
            } else {
                PublicSite.save(vm.publicSite, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('vobeApp:publicSiteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
